import {
  Box,
  Flex,
  Typography,
  css,
  selectTheme,
  styled,
} from '@creditas-ui/react';

const MenuText = styled(Typography)`
  padding: ${selectTheme('spacingY.sm')};
  margin: 0;
`;

const MenuFullWidthGrid = styled(Flex)`
  margin: ${selectTheme('spacingY.4xl')};
  margin-top: ${selectTheme('spacingY.6xl')};
  transition: border 0.25s ease-in;

  border-bottom: 2px solid ${selectTheme('colors.neutral.10')};
`;

const StyledBox = styled(Box)<{ selected?: boolean }>`
  ${({ selected }) => css`
    align-items: end;
    position: relative;
    margin-bottom: -2px;

    border-bottom-width: 2px;
    border-bottom-style: solid;
    border-bottom-color: ${selected ? '#49e295' : 'transparent'};
    transition: border 0.33s ease-in;

    &:hover {
      cursor: pointer;
    }
  `}
`;

type TabProps = {
  selected: string;
  elements: string[];
  onClick: (value: string) => void;
};

export const Tab: React.FC<TabProps> = ({ selected, elements, onClick }) => {
  return (
    <MenuFullWidthGrid flexDirection="row" alignItems="center">
      {elements.map((value) => {
        const isSelected = value === selected;

        return (
          <StyledBox
            p="1rem"
            fontSize="2xl"
            selected={isSelected}
            onClick={() => onClick(value)}
            key={value}
          >
            <MenuText
              variant={'bodyLgRegular'}
              color={isSelected ? 'neutral.90' : 'neutral.40'}
            >
              {value}
            </MenuText>
          </StyledBox>
        );
      })}
    </MenuFullWidthGrid>
  );
};
